import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import DashboardCard from "../components/DashboardCard/DashboardCard";
import AdminLayout from "../layouts/adminLayout/AdminLayout";
import { getApi } from "../config/configAxios";
import CustomLoader from "../components/CustomLoader";

const Dashboard = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    getApi(`dashboard`)
      .then((responseData) => setData(responseData.data?.data))
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  }, []);

  const generateRandomColor = () => {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  };

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <CustomLoader />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <h4>Website overview</h4>
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardCard
              icon={"tabler:photo"}
              title={"Photo Gallery"}
              subTitle={"Total"}
              countNumber={data?.photo_gallery}
              color={generateRandomColor()}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardCard
              icon={"tabler:video"}
              title={"Video Gallery"}
              subTitle={"Total"}
              countNumber={data?.video_gallery}
              color={generateRandomColor()}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardCard
              icon={"mdi:biography"}
              title={"Biography"}
              subTitle={"Total"}
              countNumber={data?.biography}
              color={generateRandomColor()}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardCard
              icon={"subway:media"}
              title={"Print Media"}
              subTitle={"Total"}
              countNumber={data?.printMedia}
              color={generateRandomColor()}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DashboardCard
              icon={"icon-park-outline:electronic-door-lock"}
              title={"Electronic Media"}
              subTitle={"Total"}
              countNumber={data?.electronicMedia}
              color={generateRandomColor()}
            />
          </Grid>
          {data?.about_us?.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <DashboardCard
                icon={"mdi:about-circle-outline"}
                title={item.title_en}
                subTitle={"Total"}
                countNumber={item.about_us_content?.length}
                color={generateRandomColor()}
              />
            </Grid>
          ))}
          {data?.resource?.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <DashboardCard
                icon={"grommet-icons:resources"}
                title={item.title_en}
                subTitle={"Total"}
                countNumber={item.resource_content?.length}
                color={generateRandomColor()}
              />
            </Grid>
          ))}
          {data?.services?.map((item, i) => (
            <Grid item xs={12} md={4} key={i}>
              <DashboardCard
                icon={"icons8:services"}
                title={item.title_en}
                subTitle={"Total"}
                countNumber={item.services?.length}
                color={generateRandomColor()}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </AdminLayout>
  );
};

export default Dashboard;
